import { render, staticRenderFns } from "./MyDashboardComponent.vue?vue&type=template&id=7c9254b1&"
import script from "./MyDashboardComponent.vue?vue&type=script&lang=js&"
export * from "./MyDashboardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports